import { getAuth, signOut } from "firebase/auth";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useMe } from "../../hooks/useMe";

function Account() {
  const me = useMe();
  const navigate = useNavigate();

  const isAdmin = useMemo(() => {
    return me && me.isAdmin;
  }, [me?.isAdmin]);

  const signOutUser = async () => {
    await signOut(getAuth());
    navigate("/login");
  };

  return (
    <div className="p-content p-setup-page">
      <div className="p-pagehead">
        <div>
          <div className="p-breadcrumb">Workspace · Accounts</div>
          <h1 className="p-pagetitle">My Account</h1>
        </div>
      </div>
    </div>
  );
}

export default Account;
